import { useState, ReactNode, useCallback, useMemo } from 'react';
import { SheetVisibilityContext } from './SheetVisibilityContext';

export const SheetVisibilityProvider = ({ children }: { children: ReactNode }) => {
    const [openCount, setOpenCount] = useState(0);

    /**
     * Counted rather than flagged. Sheets overlap, both while one opens over another and for the
     * length of a closing one's exit animation, and the first to report closing would otherwise
     * say that none are open.
     */
    const setIsSheetOpen = useCallback((open: boolean) => {
        setOpenCount(count => Math.max(0, open ? count + 1 : count - 1));
    }, []);

    const value = useMemo(
        () => ({ isSheetOpen: openCount > 0, setIsSheetOpen }),
        [openCount, setIsSheetOpen],
    );

    return (
        <SheetVisibilityContext.Provider value={value}>
            {children}
        </SheetVisibilityContext.Provider>
    );
};
